import jQuery from "jquery";

// configs
const secondsToCheckForValidation = 3;
const doWarningAtTry = 5;
const maxTries = 10;
const onSuccess_numberOfSecondsBeforeBeingRedirected = 3;
const debug = false;

let title = undefined;
let body = undefined;
let longDescr = undefined;
let spinner = undefined;
let triesContainer = undefined;
let container = undefined;
let poller = null;
let numberOfTries = 0;

// templates
const title_isloading = `<h2>Ditt konto håller på att skapas</h2>`;
const title_success = `<h2>Ditt konto har skapats!</h2>`;
const title_fail = `<h2>Något gick snett</h2>`;

const body_isloading = `<div><span>Du skickas strax till <a href="${window.globalVar_ReturnUrl}">kassan på far.se</a> där du fortsätter din beställning.</span></div>`;
const body_success = `<span class="">Du skickas nu till kassan på far.se!</span>`;
const body_fail = `<span class="">Gå tillbaka till <a href="${window.globalVar_ReturnUrl}">kassan på far.se</a> och försök att logga in själv. Om det inte fungerar ber vi dig kontakta kundservice via chatten eller<br/>telefon 08-506 112 00.</span>`;

(function (far, $) {
    if($("#createAccountScriptContainer")?.length > 0){
        container = $("#createAccountScriptContainer");
        title = $("#createAccount_Title");
        body = $("#createAccount_Body");
        longDescr = $("#longerdescriptionContainer");
        triesContainer = $("#triesContainer");
        spinner = $("#createAccount_Spinner");
        
        $(container).addClass("visible");
        
        if(debug){
            $(triesContainer).html(`<span>Försök ${numberOfTries}</span>`);
            $("#debugWrapper").append(`<div><span>Redirect to:</span><br/><span>${window.globalVar_ReturnUrl}</span></div>`);
        }
        
        $(title).html(title_isloading);
        $(body).html(body_isloading);

        poller = setInterval(doCheck.bind(this), secondsToCheckForValidation * 1000);
    }
    

    function doCheck(){
        const url = window.location.origin + "/user-sync-is-completed"; // Use origin to get base URL
        $(spinner).show();
        
        fetch(url)
        .then(responseBool => {
            if (responseBool) {
                return responseBool.json();
            } else {
                throw new Error('Network response was not ok.');
            }
        })
        .then(responseBool => {
            numberOfTries += 1;
            if(numberOfTries > maxTries){
                $(title).html(title_fail);
                $(body).html(body_fail);
                clearInterval(poller);
                $(spinner).hide();
                $(container).addClass("hideAnimateBg showErrorIcon");
                return;
            }
            if (responseBool) {
                $(title).html(title_success);
                $(body).html(body_success);
                $(longDescr).html();
                clearInterval(poller);
                $(container).addClass("hideAnimateBg showSuccessIcon");
                $(spinner).hide();
                setTimeout(()=>{
                    window.location.href = window.globalVar_ReturnUrl;
                }, onSuccess_numberOfSecondsBeforeBeingRedirected * 1000);
            } else {
                $(title).html(title_isloading);
                $(body).html(body_isloading);
            }
            if(debug){
                $(triesContainer).html(`<span>Försök ${numberOfTries}</span>`);
            }
        })
        .catch(error => {
            $(title).html(title_fail);
            $(body).html(body_fail);
            $(longDescr).html(`<pre class="error">${error}</pre>`);
            clearInterval(poller);
            $(container).addClass("hideAnimateBg showErrorIcon");
            $(spinner).hide();
        });
    
        return false;
    }
})(window.far || (window.far = {}), jQuery);